module.exports={
	"Form": "LotEditManifest",
	"Scope": "Lot-Edit",
	"Descriptors":
	{
		"LotDetails.Name":
		{
			"Name": "Name",
			"Hash": "Lot-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Lot-Edit-Identity",
				"Group": "Lot-Edit-Identity"
			}
		},
		"LotDetails.StartDate":
		{
			"Name": "Start Date",
			"Hash": "Lot-Edit-StartDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Lot-Edit-Details",
				"Group": "Lot-Edit-Details"
			}
		},
		"LotDetails.FormData":
		{
			"Name": "Form Data",
			"Hash": "Lot-Edit-FormData",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Lot-Edit-Details",
				"Group": "Lot-Edit-Details"
			}
		},
		"LotDetails.IDMixDesign":
		{
			"Name": "Mix Design",
			"Hash": "Lot-Edit-IDMixDesign",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "Lot-Edit-Details",
				"Group": "Lot-Edit-Details",
				"Entity": "MixDesign",
				"SearchFields":
				[
					"MaterialCode",
					"Name",
					"Description"
				]
			}
		},
		"LotDetails.IDContract":
		{
			"Name": "Contract",
			"Hash": "Lot-Edit-IDContract",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "Lot-Edit-Details",
				"Group": "Lot-Edit-Details",
				"Entity": "Contract",
				"SearchFields":
				[
					"Name",
					"Description",
					"PrimaryProjectNumber",
					"CountyProjectNumber"
				]
			}
		},
		"LotDetails.ValidationSequence":
		{
			"Name": "Validation Sequence",
			"Hash": "Lot-Edit-ValidationSequence",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Lot-Edit-Details",
				"Group": "Lot-Edit-Details"
			}
		},
		"LotDetails.LPSyncDate":
		{
			"Name": "LPSync Date",
			"Hash": "Lot-Edit-LPSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Lot-Edit-Details",
				"Group": "Lot-Edit-Details"
			}
		},
		"LotDetails.HLSyncDate":
		{
			"Name": "HLSync Date",
			"Hash": "Lot-Edit-HLSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Lot-Edit-Details",
				"Group": "Lot-Edit-Details"
			}
		},
		"LotDetails.IDLot":
		{
			"Name": "IDLot",
			"Hash": "Lot-Edit-IDLot",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Lot-Edit-DataAudit",
				"Group": "Lot-Edit-DataAudit"
			}
		},
		"LotDetails.GUIDLot":
		{
			"Name": "GUIDLot",
			"Hash": "Lot-Edit-GUIDLot",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Lot-Edit-DataAudit",
				"Group": "Lot-Edit-DataAudit"
			}
		},
		"LotDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Lot-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Lot-Edit-DataAudit",
				"Group": "Lot-Edit-DataAudit"
			}
		},
		"LotDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Lot-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Lot-Edit-DataAudit",
				"Group": "Lot-Edit-DataAudit"
			}
		},
		"LotDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Lot-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Lot-Edit-DataAudit",
				"Group": "Lot-Edit-DataAudit"
			}
		},
		"LotDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Lot-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Lot-Edit-DataAudit",
				"Group": "Lot-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Lot-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Lot-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Lot-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Lot-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Lot-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Lot-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
